import { CardSvg } from '@/play/cardSvg'

/** Home card art for 019 Spill: cups pouring thick coloured streams over a sand hill into pools and a lake. */
export function SpillAgainCardArt() {
  return (
    <CardSvg bg="#cfe9f6">
      {(id) => (
        <>
          <defs>
            <linearGradient id={id('sky')} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#8ec9ef" />
              <stop offset="1" stopColor="#eef7fb" />
            </linearGradient>
          </defs>
          <rect width="320" height="200" fill={`url(#${id('sky')})`} />
          {/* the land, the hill with its crater, a terrace */}
          <path d="M0 130 C 60 112, 120 118, 180 132 S 270 150, 320 138 L 320 200 L 0 200 Z" fill="#eddfc2" />
          <path d="M18 138 L 88 58 L 100 66 L 116 58 L 190 140 Z" fill="#e6d6b4" />
          <path d="M150 128 h 48 l 6 8 h -60 z" fill="#d9c49c" />
          <path d="M0 168 C 80 150, 170 158, 230 170 S 300 178, 320 172 L 320 200 L 0 200 Z" fill="#f3e8d1" />
          <g style={{ mixBlendMode: 'multiply' }}>
            {/* thick streams from above */}
            <rect x="96" y="0" width="16" height="64" rx="7" fill="#1e7ad8" opacity="0.85" />
            <rect x="236" y="0" width="16" height="140" rx="7" fill="#f0346c" opacity="0.8" />
            {/* the blue running down the channel into the terrace */}
            <path d="M110 66 C 124 86, 140 104, 168 128" stroke="#1e7ad8" strokeWidth="9" fill="none" strokeLinecap="round" opacity="0.8" />
            <path d="M152 129 h 44 l 4 5 h -52 z" fill="#1e7ad8" opacity="0.75" />
            {/* the lake: clear water, the colours spreading over it */}
            <ellipse cx="248" cy="160" rx="62" ry="13" fill="#a6e0ec" opacity="0.8" />
            <ellipse cx="236" cy="156" rx="26" ry="6" fill="#f0346c" opacity="0.6" />
            <ellipse cx="200" cy="162" rx="18" ry="4" fill="#1e7ad8" opacity="0.55" />
            {/* a bowl of yellow */}
            <ellipse cx="54" cy="160" rx="24" ry="6" fill="#ffae00" opacity="0.8" />
          </g>
          {/* splashes under the pink stream */}
          <circle cx="226" cy="146" r="3" fill="#f0346c" opacity="0.7" />
          <circle cx="262" cy="144" r="2.5" fill="#f0346c" opacity="0.7" />
        </>
      )}
    </CardSvg>
  )
}
